import { MessagesBarChart } from './MessagesBarChart';
import { UsageCard, UsageCardEmpty } from './UsageCard';

import type { UsageDayCount } from '../../team.types';

export function MessagesOverTimeCard({
  subtitle,
  series,
}: {
  subtitle: string;
  series: UsageDayCount[];
}) {
  const hasMessages = series.some((day) => day.count > 0);
  return (
    <UsageCard title="Messages over time" subtitle={subtitle}>
      {hasMessages ? (
        <MessagesBarChart series={series} height={190} />
      ) : (
        <UsageCardEmpty
          title="No messages yet"
          description="Nothing was sent in this period."
          className="h-[11.875rem]"
        />
      )}
    </UsageCard>
  );
}
